import { useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";
import LinkToUsTableSection from "../../../components/common/LinkToUsTableSection/LinkToUsTableSection";
import {
  TopBannerSection,
  LinkToUsSection,
  LinkToUsWrap,
  LinkToUsText,
  LinkToUsTextStrong,
  SuggestionsListText,
  SuggestionsUnorderedList,
  SuggestionsList,
  LinkToUsMainTable, 
} from "./linkToUsStyle";
import {
  ElliottAdvocacyBanner,
    AdvocacyTitle,
} from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import { linkToUsHandler } from "../../../redux/slices/linkToUs/linkToUs-slice";
import { useDispatch, useSelector } from "react-redux";
import MetaComponent from "../../../components/common/metaComponent";

const LinkToUs = () => {
  const dispatch: any = useDispatch();  
  const linkToUsList : any = useSelector((state:any) => state?.linkToUs?.data);

  useEffect(()=>{
    dispatch(linkToUsHandler());
  }) 
  return (
    <>
    <MetaComponent 
            keywords=""
            description=""
            ogTitle="Link to Us | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/link-to-us"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
    <>
      <TopBannerSection>
        <ElliottAdvocacyBanner className="link-to-us-banner">
          <Container className="cont-w">
            <AdvocacyTitle className="title-sub-page">Link to Us</AdvocacyTitle>
          </Container>
      </ElliottAdvocacyBanner>

      </TopBannerSection>

      <LinkToUsSection>
        <Container className="cont-w">
            <Row>
              <Col m="12">
              <LinkToUsWrap>
                  <LinkToUsText>
                    Thank you for choosing to link back to us! We love the idea that you value our service enough to tell others and help our community grow. Together we can help more nonprofits get recognized for their work. Even though we are the #1 source of stories and feedback on nonprofits and we are totally free, we realize there are many organizations who are not aware of the marketing and exposure a presence on GreatNonprofits can bring to their organization. Every day our community of donors, volunteers, and beneficiaries add more great stories about the impact of great nonprofits everywhere.
                  </LinkToUsText>
                  <LinkToUsText>
                    So - THANK YOU - again and please feel free to contact us if you have any inquiries about our logos and branding.
                  </LinkToUsText>
                  <LinkToUsText>
                    <LinkToUsTextStrong>Usage Guidelines:</LinkToUsTextStrong>
                    {" "}
                    Please do not alter the GreatNonprofits logo in any way. If you require the logo in a format or size not provided here, please contact us at 
                    <Link to =""> support@greatnonprofits.org </Link>and we will be happy to assist you.
                  </LinkToUsText>
                  <SuggestionsListText>
                    Here are some suggestions for text to place next to the logo:
                  </SuggestionsListText>
                  <SuggestionsUnorderedList>
                    <SuggestionsList>
                        Discover stories that make a difference.
                    </SuggestionsList>
                    <SuggestionsList>
                        Find stories of inspiration and information at
                        GreatNonprofits.
                    </SuggestionsList>
                    <SuggestionsList>
                        Find opportunities to give back at GreatNonprofits.
                    </SuggestionsList>
                    <SuggestionsList>
                        GreatNonprofits is the #1 source of stories and information about nonprofits. Click on the logo to find inspiration.
                    </SuggestionsList>
                    <SuggestionsList>
                        GreatNonprofits is the largest site for donors and volunteers to find inspiration and information about nonprofits. Over 20M users annually use content from GreatNonprofits.org to learn, be inspired, and become informed about nonprofits.
                    </SuggestionsList>
                  </SuggestionsUnorderedList>
              </LinkToUsWrap>
              </Col>
            </Row>
        </Container>
      </LinkToUsSection>

        <LinkToUsMainTable>
            <LinkToUsTableSection listingData={linkToUsList} />
        </LinkToUsMainTable>
    </>
    </>
    
  );
};
export default LinkToUs;
